import React, { Suspense, lazy } from 'react';
import { Spinner } from '../ui/spinner';

const ReactApexChart = lazy(() => import(/* webpackChunkName: "apexcharts" */ 'react-apexcharts'));

const CHART_HEIGHT = 320;

export function TemperatureChart({ points, seriesName, noDataText }) {
    const options = {
        chart: {
            type: 'line',
            toolbar: { show: false },
            zoom: { enabled: false },
        },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 2 },
        xaxis: {
            type: 'datetime',
            labels: {
                datetimeUTC: false,
                datetimeFormatter: {
                    year: 'dd-MM-yyyy',
                    month: 'dd-MM-yyyy',
                    day: 'dd-MM-yyyy',
                    hour: 'HH:mm',
                    minute: 'HH:mm',
                    second: 'HH:mm',
                },
            },
        },
        yaxis: {
            labels: { formatter: (value) => `${value.toFixed(1)}°C` },
        },
        tooltip: {
            x: { format: 'dd-MM-yyyy HH:mm:ss' },
            y: { formatter: (value) => `${value}°C` },
        },
        noData: { text: noDataText },
    };

    return (
        <Suspense
            fallback={(
                <div className="flex items-center justify-center" style={{ height: CHART_HEIGHT }}>
                    <Spinner className="size-8 text-[#003545]" />
                </div>
            )}
        >
            <ReactApexChart
                type="line"
                height={CHART_HEIGHT}
                options={options}
                series={[{ name: seriesName, data: points }]}
            />
        </Suspense>
    );
}
